import { IGetAllTreinamentosUseCase } from "../../../presentation/useCases/read/get_all_treinamentos_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { Treinamento } from "../../models/treinamento";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetAllTreinamentosUseCase
 */

export class GetAllTreinamentosUseCase extends BasePaginatedUseCase<Treinamento> implements IGetAllTreinamentosUseCase {
  constructor(private readonly repository: IRhRepository) {
    super();
  }

  async getAllTreinamentos(
    tipoPesquisa: number,
    valueField: string,
    status: number,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllTreinamentos(
      tipoPesquisa,
      valueField,
      status,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
